import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Icon, Link as ChakraLink, Text, useStyleConfig, } from '@chakra-ui/react';
import { BxLinkExternal } from '../icons';
export const Link = forwardRef(({ externalLinkIcon = _jsx(Link.ExternalIcon, {}), isDisabled, children, ...props }, ref) => {
    const styles = useStyleConfig('Link', props);
    if (isDisabled) {
        return (_jsxs(Text, { as: "a", ref: ref, sx: props.sx ?? styles, "aria-disabled": true, alignItems: "center", children: [children, props.isExternal && externalLinkIcon] }));
    }
    return (_jsxs(ChakraLink, { display: "inline-flex", alignItems: "center", ...props, ref: ref, children: [children, props.isExternal && externalLinkIcon] }));
});
const ExternalIcon = () => {
    return (_jsx(Icon, { "aria-hidden": true, as: BxLinkExternal, ml: "0.25rem", verticalAlign: "middle" }));
};
Link.displayName = 'Link';
Link.ExternalIcon = ExternalIcon;
Link.ExternalIcon.displayName = 'Link.ExternalIcon';
